module.exports = __webpack_public_path__ + "img/4.85d765d7.webp";